module.exports = __webpack_public_path__ + "assets/img/Facebook.5607d67a.png";